import React from 'react';
import "../../App.css";

export default function Faith() {
    
    return <h1 className="ph-text f-25">I believe in one God, Father Almighty, Creator of heaven and earth, and of all things visible and invisible.<br></br>

    And in one Lord Jesus Christ, the only-begotten Son of God, begotten of the Father before all ages; Light of Light, true God of true God, begotten, not created, of one essence with the Father through Whom all things were made. Who for us men and for our salvation came down from heaven and was incarnate of the Holy Spirit and the Virgin Mary and became man. He was crucified for us under Pontius Pilate, and suffered and was buried; And He rose on the third day, according to the Scriptures. He ascended into heaven and is seated at the right hand of the Father; And He will come again with glory to judge the living and dead. His kingdom shall have no end.<br></br>
    
    And in the Holy Spirit, the Lord, the Creator of life, Who proceeds from the Father, Who together with the Father and the Son is worshipped and glorified, Who spoke through the prophets.<br></br>
    
    In one, holy, catholic, and apostolic Church.<br></br>
    
    I confess one baptism for the forgiveness of sins.<br></br>
    
    I look for the resurrection of the dead, and the life of the age to come.<br></br>
    
    Amen.</h1>
    
    
}




